import { FC } from 'react'

import { SiteInfoComponent } from '@/app/shared/components/site-info'
import { ITypeSite } from '@/app/shared/store/layout.store'
import { ContainerComponent } from '@/app/shared/ui/container'
import { LogoComponent } from '@/app/shared/ui/logo'

interface IFooterProps {
  typeSite: ITypeSite | null
}

const FooterComponent: FC<IFooterProps> = ({ typeSite }) => {
  return (
    <footer>
      <ContainerComponent
        className={
          'flex items-center justify-between bg-success text-content1-700 max-tablet:flex-col max-tablet:gap-12 max-tablet:pb-[50px] extraMobile:flex tablet:py-[50px] large:flex-nowrap'
        }
      >
        <LogoComponent
          footer
          text={`Школа ${typeSite === 'online-deutsch' ? 'німецької' : typeSite === 'online-espanol' ? 'іспанської' : 'англійської'} мови в Києві`}
          className={
            'max-tablet:m-auto max-tablet:flex max-tablet:w-fit max-tablet:flex-col max-tablet:items-center extraMobile:mb-0'
          }
          typeSite={typeSite}
        />
        <SiteInfoComponent
          className={
            'mr-0 w-fit max-tablet:flex-col tablet:ml-auto tablet:max-large:grid tablet:max-large:grid-cols-[auto_auto]'
          }
        />
      </ContainerComponent>
    </footer>
  )
}

export default FooterComponent
